import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
// import { ToasterService } from 'angular2-toaster';

import { routes } from './routes';

@NgModule({
  declarations: [],
  imports: [SharedModule, RouterModule.forRoot(routes)],
  // providers: [ToasterService],
  exports: [RouterModule],
})
export class RoutesModule {
  constructor() {}
}
